import { useState } from 'react';
import { stageInfo, getHotspotsByStage } from '../../data/notationHotspots';
import type { Stage } from '../../data/notationHotspots';
import { StageProgressBar } from './StageProgressBar';
import { GuidedMode } from './GuidedMode';
import './MobileStageDrawer.css';

interface MobileStageDrawerProps {
  currentStage: Stage;
  exploredByStage: Record<Stage, Set<string>>;
  exploredIds: Set<string>;
  onSelectStage: (stage: Stage) => void;
  onSelectHotspot: (id: string) => void;
}

export function MobileStageDrawer({
  currentStage,
  exploredByStage,
  exploredIds,
  onSelectStage,
  onSelectHotspot,
}: MobileStageDrawerProps) {
  const [expanded, setExpanded] = useState(false);

  const info = stageInfo[currentStage];
  const explored = exploredByStage[currentStage]?.size || 0;
  const total = getHotspotsByStage(currentStage).length;
  const fraction = total > 0 ? `${explored}/${total}` : '';
  const pct = total > 0 ? (explored / total) * 100 : 0;

  return (
    <div className={`mobile-stage-drawer ${expanded ? 'mobile-stage-drawer--expanded' : ''}`}>
      {expanded && (
        <div className="mobile-stage-drawer__panel">
          <div className="mobile-stage-drawer__panel-content">
            <StageProgressBar
              currentStage={currentStage}
              exploredByStage={exploredByStage}
              onSelectStage={onSelectStage}
            />
            {currentStage >= 1 && currentStage <= 3 && (
              <GuidedMode
                currentStage={currentStage}
                onSelectHotspot={onSelectHotspot}
                exploredIds={exploredIds}
              />
            )}
          </div>
        </div>
      )}
      <div
        className="mobile-stage-drawer__bar"
        onClick={() => setExpanded(prev => !prev)}
      >
        <span className="mobile-stage-drawer__pip" style={{ background: info.color }} />
        <span className="mobile-stage-drawer__label">{info.label}</span>
        <span className="mobile-stage-drawer__fraction">{fraction}</span>
        <div className="mobile-stage-drawer__progress">
          <div
            className="mobile-stage-drawer__progress-fill"
            style={{ width: `${pct}%`, background: info.color }}
          />
        </div>
        <i className="fas fa-chevron-up mobile-stage-drawer__chevron" />
      </div>
    </div>
  );
}
